import { useEffect, useId } from 'react';
import useGuideStore from '@/data/store/useGuideStore';

export default function useGuideBlocker(blocked) {
    const id = useId();
    useEffect(() => {
        useGuideStore.getState().setBlocker(id, !!blocked);
        return () => useGuideStore.getState().setBlocker(id, false);
    }, [id, blocked]);
}
